module.exports = __webpack_public_path__ + "static/11-ab6aea8aec0a72c05ee9e880f6b889f3.jpg";